// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3669 ? "97fdc96b" : chunkId) + "." + {"1102":"966cb53242b31d1c","3669":"7fa05ad66a52e2b8","6844":"27fbcda11343c03b","9790":"4d5bd7aee468decc"}[chunkId] + ".js";
};